<template>
    <header class="fixed top-0 right-0 left-0 z-50 bg-white shadow-md dark:bg-gray-900">
        <nav class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="flex justify-between h-16">
                <div class="flex items-center">
                    <a href="/" class="flex items-center space-x-2">
                    <img src="/logo.svg" alt="BoxBuddy" class="w-8 h-8">
                    <span class="text-xl font-bold text-gray-900 dark:text-white">BoxBuddy</span>
                    </a>
                </div>
                <div class="flex items-center space-x-4" v-if="!authUser">
                    <RouterLink :to="{ name: ROUTES.LOGIN }"
                        class="px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                    Login
                    </RouterLink>
                    <RouterLink :to="{ name: ROUTES.REGISTER }"
                        class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600">
                    Register
                  </RouterLink>
                </div>
                <div v-else class="flex items-center space-x-4">

                    <SettingsDropDown />
                </div>
            </div>
        </nav>
    </header>
</template>

<script setup>
import SettingsDropDown from '@/components/general/SettingsDropDown.vue';
import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { storeToRefs } from 'pinia';
import { ROUTES } from '@/router/routeNames';

const auth = useAuthStore()
const { user: authUser } = storeToRefs(auth)

</script>
